<template>
  <div v-if="showAction">
    <div class="actionTextBox" :style="'opacity:'+textOpacity+';width:'+actionWidth+'px;'">
        <div class="content">
          <video  ref="helpVid" class="voiceGraph" src="../../assets/voice/ai/AI_welcome.mp4" width="500px" style="position:absolute;"></video>
          <div v-if="vidEnded" class="voiceBtns">
              <div @click="doHelpBtn('again')" class="voiceBtn">replay help</div>
              <div  @click="doHelpBtn('next')" class="voiceBtn">next topic</div> 
          </div>
      <div class="ActionAI_Large"><div class="AI_LargeInner" style="margin:10px;"></div></div>
      <div v-if="true" class="helpClose" @click="helpOut">x</div>
      <div class="actionText" :style="'width:'+(actionWidth-350)+'px;'">
      <div v-if="!typeHelp" >{{actionText}}</div>
      <TypeOn v-if="showAction && typeHelp" :speed="typeSpeed" v-html="actionText" style="min-height:50px;"></TypeOn>
      <div v-if="!showDetails" @click="showDetails=true" class="voiceBtn teal-text" style="width:250px;pointer-events:auto;margin-top:10px;">Extract Details</div> 
      <div v-else>
         <div class="padTop teal-text" v-if="document.info"><br>Details:<br>
           <div v-for="(info,e) in infoList" :key="'info'+e" > <TypeOn  :speed="typeSpeed" :delay="e*2000" v-html="info.desc"></TypeOn></div>
         </div>
          <div v-if="!showEvidence && evidenceList" @click="showEvidence=true" class="voiceBtn orange-text" style="width:250px; pointer-events:auto;margin-top:10px;">Reveal Evidence</div> 
          <div v-else>
            <div class="padTop orange-text" v-if="evidenceList"><br>Possible Evidence: <span v-if="tip!='PE'" class="ttip" @mouseover="tip='PE'">(?)</span><span v-else class="ttip" @mouseout="tip=null">(Check the box to store as evidence)</span><br> 
             
                <div v-for="(evi,ev) in evidenceList" :key="'evi'+ev" @click="doAction(evidenceItem(evi),eviCheck[ev])"><div v-if="evidenceItem(evi)" class="docOpt"><TypeOn  :speed="typeSpeed" :delay="ev*2000" v-html="evidenceItem(evi).description" style="display:inline-block;"></TypeOn>
                  &nbsp; <p-check  :class="getClass(eviCheck[ev])" name="eviCheck" color="warning" value="custom" v-model="eviCheck[ev]">
                    </p-check></div>
                </div>
              </div>
              <div v-if="false" class="padTop orange-text">Document Contains no Evidence</div>
            
            <div v-if="actionList && !showActionList" @click="showActionList=true" class="voiceBtn green-text" style="width:250px; pointer-events:auto;margin-top:10px;">Take Action</div> 
            <div v-else>
              <div class="padTop green-text" v-if="actionList"><br>Actions:
                <div v-for="(act,a) in actionList" :key="'act'+a" @click="doAction(actionItem(act),actCheck[a])" class="docOpt"><TypeOn  :speed="typeSpeed" :delay="a*2000" v-html="actionItem(act).text"  style="display:inline-block;"></TypeOn>
                   &nbsp; <p-check :class="getClass(actCheck[a])" name="acCheck" color="success" value="custom" v-model="actCheck[a]"></p-check>
                </div> 
              </div>
              <div v-if="docScene" class="sceneBtn" @click="showScene(docScene)">
            Scene Unlocked
           </div>
            
            </div>
          </div>
         
      </div>
       <div class="basicBtn"  @click="helpOut" style="transform:scale(0.8); opacity:0.6;width:160px;">Close Results</div>
       <div style="height:50px;"><br></div>
        
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import screen from "@/mixins/screen"
import TypeOn from '@/components/TypeOn'
import Nodes from '@/mixins/nodes'
export default {
  mixins:[Nodes, screen],
  components: {
   TypeOn
  },
 
  data() {
    return {
      
       showAction:false,
       showDetails:false,
       showEvidence:false,
       showActionList:false,
       textOpacity:1,
       vidEnded:false,
       aiPath:"../../assets/voice/ai/",
       tip:null
    };
  },
  mounted(){
    this.showAction=this.showActions
    console.log("Action Panel",this.document)
    console.log(" evidenceList", this.evidenceList)
    console.log(" actionList", this.actionList)
  },
  computed:{
    infoList(){
      if(this.document && this.document.info){
        return this.getInfo(this.document.info)
      }
    },
    docScene(){
       if(this.document){
        return this.document.scene
      }
    },
    evidenceList(){
      if(this.document){
        
        return this.getEvidence(this.document.evidence)
      }
    },
    actionList(){
      if(this.document){
        return this.getActions(this.document.actions)
      }
    },
    actionText(){
      if(this.document){
        return this.document.description
      }
    },
    actionWidth(){
      
        return Math.min(this.windowWidth*.9,1100)
     
    },
    helpInnerMax(){
      return Math.max(this.windowWidth,this.windowHeight)*2
    },
    helpText(){
      if(this.document)
      {
        return this.document.text
      }
    },
    typeSpeed(){
      if(this.document)
      {
        return this.document.writeSpeed || 0.05
      }
      return 0.05
    },
    helpState(){
      if(this.document)
      {
      return this.document.state
      }
    },
     showAI(){
      if(this.document){
        return this.document.showAI=="true"
      }
    },
    typeHelp(){
      if(this.document){
        return this.document.writeOn || true
      }
    },
    document(){
      return this.$store.getters.getDocAction
    }
  },
  methods:{
    showScene(scene){
       console.log("Set Cut Scene",scene)
      this.helpOut()
      this.$store.commit("setCutScene",scene)
    },
    getClass(val){
      if(val){
        
        return "p-locked"
      }
    },
      doHelpBtn(mode){
        if(mode=="again"){
           this.playVideo()
        }else{
           this.$store.dispatch("nextHelp")
           this.$nextTick(() => {
              console.log("PLAY NEXT",this.document,this.$store.getters.getHelp)
              this.playVideo()
           })
          
        }
       
        //alert("BTN")
      },
    	playVideo(){
        
        //let file=require("../../assets/voice/ai/AIDA_welcome.mp4")
        let file=require("../../assets/voice/ai/"+this.document.file)
        console.log("PLAY VIDEO",this.document)
        //console.log("PLAY VIDEO","../../assets/voice/ai/AIDA_welcome.mp4")
        this.$refs.helpVid.src=file
        this.$refs.helpVid.load()
        this.$refs.helpVid.addEventListener('canplay',this.justPlay)
				//this.$refs.helpVid.addEventListener('ended',this.videoEnded)
				
			},
		justPlay(){
				console.log("CAN PLAY")
				this.$refs.helpVid.play()
				this.$refs.helpVid.removeEventListener('canplay',this.justPlay)
      },
      videoEnded(){
        this.vidEnded=true
        
      },
    helpIn(){
      this.showAction=true
     
      gsap.to(this,.3,{textOpacity:1,onComplete:this.helpHold})
    },
    helpHold(){
      
      //gsap.delayedCall(1.5,this.helpOut)
     
    },
    helpClick(){
      if(!this.showAI){
        this.helpOut()
      }
      
    },
    helpOut(){
      gsap.to(this,.3,{textOpacity:0,onComplete:this.helpDone})
    
      
    },
    helpDone(){
       this.showAction=false
       this.$store.commit('setDocAction',null)
       
    }
  },
  watch:{
    docScene(val){
      if(val){
        // alert("HAS SCENE "+val)
      }
    },
    evidenceList(val){
      
    },
    document(val){
       this.eviCheck=[]
       this.actCheck=[]
       this.showEvidence=false
        this.showAction=false
        this.showDetails=false
        this.showActionList=false
      if(val){
        this.helpIn()
        //this.showAction=true
      }else{
        this.showAction=false
      }
      console.log(" evidenceList", this.evidenceList)
      console.log(" actionList", this.actionList)
    },
      showActions(val){
          console.log("SHOW ACTIONS",this.showActions)
          if(val){
              this.helpIn()
          }
         
      },
    helpState(val){
      if(val=="helpIn"){
        this.helpIn()
      }else{
        this.helpOut()
       
      }
    },
    showAI(val){
      if(val){
        let self=this
        this.$nextTick(() => {
          this.vidEnded=false
          this.$refs.helpVid.addEventListener('ended',this.videoEnded)
          this.playVideo()
        })
        
      }
    }
  }
};
</script>
<style scoped>
.pretty{
    top: 4px;
    margin-left: .5em;
    position: absolute!important;
  
  }
  .helpText{
    
    min-height:200px;

  }
  </style>
<style>
.ttip{
  color:orange;
  cursor:help;
}

  .transission{
    z-index: 3;
    position:absolute;
    left:calc(50% - 1050px);
    top:calc(50% - 1050px);
    width:100px;
    height:100px;
    border-radius:50%;
    border:#000 solid 1000px;
  }
  .docOpt{
    /*width:calc(100% + 30px);*/
    position:relative;
  }
  .actionTextBox{
    z-index: 4;
    font-size:20px;
    width:90%;
   
    border-radius:10px;
    text-align:left;
    position:absolute;
    left:0px;
    right:0px;
    top: 10%;
    bottom: 10%;
    overflow: hidden;
    color:#fff;
    margin:auto;
    
  }
  .actionTextBox .content{
      background-color:#000;
       min-height:300px;
       opacity:.8;
  }
  .actionText{
    position:relative;
    background-color:#000000b4;
    padding:10px;
    width:480px;
    min-height:80px;
    max-height: 80vh;
    overflow-y: auto;
  }
 
  
  
  .ActionAI_Large{
    position: absolute;
    top: 0px;
    right: 0px;
    width: 300px;
    min-height: 300px;
    height: 100%;

  }
  .AI_LargeInner{
    position: absolute;
    top: 10px;
    right: 10px;
    width: 280px;
     height: 280px;
    background-image: url(/img/AI.87a28f9f.png);
    background-size: 280px 280px;
    background-repeat: no-repeat;
    background-position: 0px 0px;
    border-radius: 50%;
    box-shadow: inset #43c2ff 0px 0px 20px 10px;
   
  }
  .helpClose{
    position: absolute;
    top: 0px;
    right: 0px;
    cursor: pointer;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    text-align: center;
  }
  .helpClose:hover{
    background-color: #3e3e3e;
  }
</style>